(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-collection-seo"] && !Shopify.designMode) return;
  try {
    
  // Uzun SSS/SEO metinlerini katlar. Metin DOM'da her zaman tam olarak
  // durur; yalnizca gorsel yukseklik kisilir. Boylece arama motoru ve
  // ekran okuyucu icerigin tamamini gorur.
  class HCSeoText extends HTMLElement {
    connectedCallback() {
      this.rte = this.querySelector('.th-seo__rte');
      if (!this.rte) return;

      const collapsed = parseInt(this.dataset.collapsedHeight, 10);
      if (!collapsed) return;

      this.style.setProperty('--collapsed-height', collapsed + 'px');

      // Metin zaten kisaysa dugme basmaya gerek yok.
      if (this.rte.scrollHeight <= collapsed + 24) return;

      this.classList.add('th-seo__body--collapsible');

      this.toggle = document.createElement('button');
      this.toggle.type = 'button';
      this.toggle.className = 'th-seo__toggle';
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.textContent = this.dataset.labelMore;
      this.toggle.addEventListener('click', this.onToggle);
      this.appendChild(this.toggle);
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
    }

    onToggle = () => {
      const expanded = this.toggle.getAttribute('aria-expanded') !== 'true';
      this.classList.toggle('th-seo__body--expanded', expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.textContent = expanded ? this.dataset.labelLess : this.dataset.labelMore;
    };
  }

  if (!customElements.get('th-seo-text')) {
    customElements.define('th-seo-text', HCSeoText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-collection-text"] && !Shopify.designMode) return;
  try {
    
  class ThCtText extends HTMLElement {
    connectedCallback() {
      this.rte = this.querySelector('.th-ct__rte');
      if (!this.rte) return;
      var h = parseInt(this.dataset.h, 10);
      if (!h) return;
      this.style.setProperty('--ch', h + 'px');
      if (this.rte.scrollHeight <= h + 24) return;
      this.classList.add('th-ct__body--collapsible');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'th-ct__toggle';
      b.setAttribute('aria-expanded', 'false');
      b.textContent = this.dataset.more;
      var self = this;
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') !== 'true';
        self.classList.toggle('th-ct__body--open', open);
        b.setAttribute('aria-expanded', String(open));
        b.textContent = open ? self.dataset.less : self.dataset.more;
      });
      this.appendChild(b);
    }
  }
  if (!customElements.get('th-ct-text')) customElements.define('th-ct-text', ThCtText);

  } catch(e) { console.error(e); }
})();
})();
